module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/level-4_start-c17cc4dc78e516c70bccdc9f31237926.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/level-4_start.png
// module id = 443
// module chunks = 2